import ExperienceCardContent from "./experience/ExperienceCardContent";
import TransportationCardContent from "./transportation/TransportationCardContent";
import RentacarCardContent from "./rentacar/RentacarCardContent";
import StandardInfo from "../components/ProductInfo/StandardInfo";
import RoomInfo from "./lodge/RoomInfo";
import RentacarFilter from "./rentacar/RentacarFilter";
import LodgeFilter from "./lodge/LodgeFilter";
import RestaurantFilter from "./restaurant/RestaurantFilter";
import ExperienceFilter from "./experience/ExperienceFilter";
import GoodsFilter from "./goods/GoodsFilter";
import GuideFilter from "./guide/GuideFilter";
import EventCardContent from "./event/EventCardContent";

import { FaLeaf, FaTaxi } from "react-icons/fa";
import { GiAirBalloon, GiCarKey, GiCastle } from "react-icons/gi";
import { RiCalendarEventFill, RiShoppingBasketFill } from "react-icons/ri";
import { IoIosPeople, IoMdRestaurant } from "react-icons/io";
import { MdEvent, MdHotel, MdOutlinePedalBike } from "react-icons/md";
import { ICON_SIZE } from "../config/layoutConfig";
import EventFilter from "./event/EventFilter";
import GoodsCardContent from "./goods/GoodsCardContent";
import RoomCardContent from "./lodge/RoomCardContent";
import RoomFilter from "./lodge/RoomFilter";
import MenuFilter from "./restaurant/MenuFilter";
import StoreExperienceFilter from "./experience/StoreExperienceFilter";
import TransportationFilter from "./transportation/TransportationFilter";
import MenuCardContent from "./restaurant/MenuCardContent";
import { addGoodsToCart } from "./goods/addGoodsToCart";
import { addMenuOrTableToCart } from "./restaurant/addMenuOrTableToCart";
import { addRoomToCart } from "./lodge/addRoomToCart";
import RentabikeCardContent from "./rentabike/RentabikeCardContent";
import RentabikeFilter from "./rentabike/RentabikeFilter";
import { GrBike } from "react-icons/gr";
import MonumentFilter from "./monument/MonumentFilter";
import TicketFilter from "./monument/TicketFilter";
import MonumentCardContent from "./monument/MonumentCardContent";
import CreativeCardContent from "./creative/CreativeCardContent";
import EventTicketFilter from "./event/EventTicketFilter";
import RentacarInfo from "./rentacar/RentacarInfo";
import GoodsStoreFilter from "./goods/GoodsStoreFilter";
import GuideCardContent from "./guide/GuideCardContent";

const ICON_STYLE = { margin: "0px 10px -5px 0px" };

const productionShowInHomeMenu = {
  lodge: false,
  restaurant: false,
  experience: false,
  guide: false,
  event: false,
  goods: false,
  transportation: false,
  rentacar: true,
  rentabike: false,
  monument: false,
  creative: false,
};

const stagingShowInHomeMenu = {
  lodge: true,
  restaurant: true,
  experience: true,
  guide: true,
  event: true,
  goods: true,
  transportation: true,
  rentacar: true,
  rentabike: true,
  monument: true,
  creative: false,
};

const showInHomeMenu =
  process.env.REACT_APP_ENV === "production"
    ? productionShowInHomeMenu
    : stagingShowInHomeMenu;

export const ENTITIES = {
  lodge: {
    // Home
    showInHomeMenu: showInHomeMenu.lodge || false,
    icon: <MdHotel size={ICON_SIZE} style={ICON_STYLE} />,
    label: "whereToSleep",
    HomeFilter: LodgeFilter,
    hasVillagesSearch: true,
    hasNameSearch: true,
    typeOfList: "store",
    // Store
    StoreFilter: RoomFilter,
    // Store card
    subDir: "local",
    // Card
    CardContent: RoomCardContent,
    InfoContent: RoomInfo,
    addToCart: addRoomToCart,
  },
  restaurant: {
    // Home
    showInHomeMenu: showInHomeMenu.restaurant || false,
    icon: <IoMdRestaurant size={ICON_SIZE} style={ICON_STYLE} />,
    label: "whereToEat",
    HomeFilter: RestaurantFilter,
    hasVillagesSearch: true,
    hasNameSearch: true,
    typeOfList: "store",
    // Store
    StoreFilter: MenuFilter,
    // Store card
    subDir: "local",
    // Card
    CardContent: MenuCardContent,
    InfoContent: StandardInfo,
    addToCart: addMenuOrTableToCart,
  },
  experience: {
    // Home
    showInHomeMenu: showInHomeMenu.experience || false,
    icon: <GiAirBalloon size={ICON_SIZE} style={ICON_STYLE} />,
    label: "whatToDo",
    HomeFilter: ExperienceFilter,
    hasVillagesSearch: false,
    hasNameSearch: false,
    typeOfList: "store",
    // typeOfList: "product",
    // Store
    StoreFilter: StoreExperienceFilter,
    // Store card
    subDir: "local",
    // Card
    CardContent: ExperienceCardContent,
    InfoContent: StandardInfo,
  },
  guide: {
    // Home
    showInHomeMenu: showInHomeMenu.guide || false,
    icon: <IoIosPeople size={ICON_SIZE} style={ICON_STYLE} />,
    label: "guides",
    HomeFilter: GuideFilter,
    hasVillagesSearch: false,
    hasNameSearch: false,
    typeOfList: "product",
    // Store
    StoreFilter: GuideFilter,
    // Store card
    subDir: "local",
    // Card
    // ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR ALTERAR
    CardContent: GuideCardContent,
    InfoContent: StandardInfo,
  },
  event: {
    // Home
    showInHomeMenu: showInHomeMenu.event || false,
    icon: <RiCalendarEventFill size={ICON_SIZE} style={ICON_STYLE} />,
    label: "events",
    HomeFilter: EventFilter,
    hasVillagesSearch: true,
    hasNameSearch: false,
    typeOfList: "store",
    // Store
    // Store card
    subDir: "evento",
    // event has no filter, beacuse store will show the small list of ticket types available
    StoreFilter: EventTicketFilter, // doesn't have a store yet
    // Card
    CardContent: EventCardContent,
    InfoContent: StandardInfo,
  },
  goods: {
    // Home
    showInHomeMenu: showInHomeMenu.goods || false,
    icon: <RiShoppingBasketFill size={ICON_SIZE} style={ICON_STYLE} />,
    label: "ahpMarket",
    HomeFilter: GoodsStoreFilter,
    hasVillagesSearch: true,
    hasNameSearch: false,
    typeOfList: "store",
    // Store
    StoreFilter: GoodsFilter,
    // Store card
    subDir: "local",
    // Card
    CardContent: GoodsCardContent,
    InfoContent: StandardInfo,
    addToCart: addGoodsToCart,
  },
  transportation: {
    // Home
    showInHomeMenu: showInHomeMenu.transportation || false,
    icon: <FaTaxi size={ICON_SIZE} style={ICON_STYLE} />,
    label: "transportation",
    HomeFilter: TransportationFilter,
    hasVillagesSearch: false,
    hasNameSearch: false,
    typeOfList: "product",
    // Store
    StoreFilter: null, // doesn't have a store yet
    // Store card
    subDir: "local",
    // Card
    CardContent: TransportationCardContent,
    InfoContent: StandardInfo,
  },
  rentacar: {
    // Home
    showInHomeMenu: showInHomeMenu.rentacar || false,
    icon: <FaLeaf size={ICON_SIZE} style={ICON_STYLE} />,
    label: "mobility",
    HomeFilter: RentacarFilter,
    hasVillagesSearch: false,
    hasNameSearch: false,
    typeOfList: "product",
    // Store
    StoreFilter: null, // doesn't have a store yet
    // Store card
    subDir: "local",
    // Card
    CardContent: RentacarCardContent,
    InfoContent: RentacarInfo,
  },
  rentabike: {
    // Home
    showInHomeMenu: showInHomeMenu.rentabike || false,
    icon: <GrBike size={ICON_SIZE} style={ICON_STYLE} />,
    label: "rentabike",
    HomeFilter: RentabikeFilter,
    hasVillagesSearch: false,
    hasNameSearch: false,
    typeOfList: "product",
    // Store
    StoreFilter: null, // doesn't have a store yet
    // Store card
    subDir: "local",
    // Card
    CardContent: RentabikeCardContent,
    InfoContent: StandardInfo,
  },
  monument: {
    // Home
    showInHomeMenu: showInHomeMenu.monument || false,
    icon: <GiCastle size={ICON_SIZE} style={ICON_STYLE} />,
    label: "historicCulturalSpaces",
    HomeFilter: MonumentFilter,
    hasVillagesSearch: true,
    hasNameSearch: true,
    typeOfList: "store",
    // Store
    StoreFilter: TicketFilter,
    // Store card
    subDir: "local",
    // Card
    CardContent: MonumentCardContent,
    InfoContent: StandardInfo,
    addToCart: addRoomToCart,
  },
  creative: {
    // Home
    showInHomeMenu: showInHomeMenu.creative || false,
    // icon: <GrBike size={ICON_SIZE} style={ICON_STYLE} />,
    label: "creativeIndustries",
    // Store
    // Card
    // Store card
    subDir: "local",
    CardContent: CreativeCardContent,
    InfoContent: StandardInfo,
    // HomeFilter: RentabikeFilter,
    // StoreFilter: null, // doesn't have a store yet
    // hasVillagesSearch: false,
    // hasNameSearch: false,
    // typeOfList: "product",
  },
};
